/* eslint react/no-direct-mutation-state: "off",'no-redeclare': 'off','no-loop-func' : 'off', eqeqeq: 'off' */  
import React, { Component } from 'react';
import { Row,Col, Button, FormGroup, Table } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';
import { GetZonesList, GetBuildingMembersList, GetMembersFromFamily, UpdateZone } from '../../../../../../action/ZonesAction';
import SearchInput, {createFilter} from 'react-search-input';

let SelectedZoneId = 0; //eslint-disable-line
let zonedts = [];
let ZoneId = 0, BuildingId = 0, ZoneName, BuildingName;
const KEYS_TO_FILTERS = ['objectName'];
let Error_Msg = 'Error: You left necessary fields blank or entered invalid values.'
class EditZoneForm extends Component {
    componentWillMount(){
        SelectedZoneId = this.props.parentToChildData[0];
        zonedts = this.props.parentToChildData[1];
        this.setState({
            member_during_initalLoad : JSON.parse(this.props.jsonmembers),
        });
    }
    componentDidMount(){
        this.props.GetBuildingMembersList(BuildingId);
    }

    constructor(props) {
        super(props);
        this.state = { 
            error:false,
            SelectedRows:[],
            searchTerm: '',
            Isfirst:false,
            available_members_in_state:[],
            selected_members_in_state:[],
            member_during_initalLoad:[],
        }
        this.UpdateZone = this.UpdateZone.bind(this);
        this.CloseModal = this.CloseModal.bind(this);
        this.changeMemberType = this.changeMemberType.bind(this);
        this.moveRowsToRight = this.moveRowsToRight.bind(this);
        this.moveRowsToLeft = this.moveRowsToLeft.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.comparer = this.comparer.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(this.props != nextProps) {
            this.setState({available_members_in_state : nextProps.Response_of_MembersCall.MembersList  });
        }
    }

    searchUpdated (term) {
        this.setState({searchTerm: term , MoveRowsRight: false})
      }

    UpdateZone(){
        var selectedRecords = this.state.selected_members_in_state;
        var Zone_Name = this.refs.New_Zone_Name.value;
        var IsValid = true;
        Error_Msg = 'Error: You left necessary fields blank or entered invalid values.'
        if(this.props.getResponse != undefined && this.props.getResponse.ZonesList != null){
            let lstZones = this.props.getResponse.ZonesList;
            if(lstZones != undefined && lstZones.length > 0){
                lstZones = lstZones.filter(function(item){
                return Zone_Name == item.zoneName && ZoneId != item.zoneId
                });
                if(lstZones != null && lstZones.length > 0){
                    Error_Msg = 'Error: Duplicate Zone Name.';
                    IsValid = false;
                }
            }
        }

        if(selectedRecords.length>0 && Zone_Name != "" && IsValid){
            this.setState({ SelectedRows: selectedRecords },()=>{
                var data = {
                    "ZoneId": ZoneId,
                    "zoneName": Zone_Name,
                    "buildingId": BuildingId,
                    "members": this.state.SelectedRows
                    }
            
                this.props.UpdateZone(data);
                this.props.closeModalPopUp("close");
            });
        }
        else{
            this.setState({error: true });
        }
    }

    CloseModal()  {
            this.props.closeModalPopUp("close");
    }
    
    changeMemberType(){
        var selectoption = document.getElementById("MemberSelectoption");
        var familyId = selectoption.options[selectoption.selectedIndex].value;
       if(zonedts !== undefined && zonedts !== null){
            this.setState({MoveRowsRight:false});
            if(familyId=="ShowAll"){
                this.props.GetBuildingMembersList(zonedts[0].buildingId);
            }
            else{
                this.props.GetMembersFromFamily(zonedts[0].buildingId,familyId);
            }
        }
    }
    comparer(otherArray){
        if(otherArray.length>0){
                return function(current){
                  return otherArray.filter(function(other){
                    return other.objectId == current.objectId && other.objectName == current.objectName
                  }).length == 0;
                }
            }
            } 
    moveRowsToRight() {
        var RowstobeMoved_SM = [];

        if(this.state.selected_members_in_state.length>0){
            var RowstobeMoved_SM = this.state.selected_members_in_state;
        }
        var checkboxes = document.getElementsByClassName('Available_members_left');

        for (var i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked === true){
                var x = checkboxes[i].id;
                 var MembersArray= this.state.available_members_in_state;
                 var obj = MembersArray.filter(function (obj) { return obj.objectId == x })[0];
                 RowstobeMoved_SM.push(obj);
            }
        }
        this.setState({selected_members_in_state:RowstobeMoved_SM });
    }

    moveRowsToLeft() {
        var RowstobeMoved_SM = [];
        
        var checkboxes = document.getElementsByClassName('Available_members_right');
        for (var i = 0; i < checkboxes.length; i++) {
            if(checkboxes[i].checked === false){
                var x = checkboxes[i].id;
                 var MembersArray= this.state.selected_members_in_state;
                 var obj = MembersArray.filter(function (obj) { return obj.objectId == x })[0];
                 RowstobeMoved_SM.push(obj);
            }
        }
        this.setState({selected_members_in_state : RowstobeMoved_SM });
    }
    render(getResponse, Response_of_MembersCall, getLabels){
        let modal_form_1, Available_members, Selected_Members;
        let label = this.props.getLabels;
        
         //Getting Selected Zone Details
        if (zonedts !== undefined && zonedts !== null && !this.state.Isfirst) {
            ZoneName = zonedts[0].zoneName;
            BuildingName = zonedts[0].buildingName;
            ZoneId = zonedts[0].zoneId;
            BuildingId = zonedts[0].buildingId;
            this.state.selected_members_in_state =  this.state.member_during_initalLoad[0].members;
            this.state.Isfirst = true;
        }
      
        let data, data2,FilteredData;
        data = this.state.available_members_in_state;
        data2 = this.state.selected_members_in_state;

        if (data != undefined && data.length > 0 && data != null) {
            if (data2.length == 0) {
                FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                if (FilteredData.length != 0) {
                    Available_members = FilteredData.map(el => (
                        <tr id={el.objectId} className="RightTablerecords" key={el.objectId}>
                            <td><input type="checkbox" id={el.objectId} className="Available_members_left" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Available_members_left", "available_members_header_Check_box"); }} /></td>
                            <td id={el.objectId}>{el.objectName}</td>
                        </tr>
                    ));
                }
                else {
                    Available_members = <tr><td>{label['NoRecords.Text']}</td></tr>
                }
            }
            else {

                var Available_members_Data = this.state.available_members_in_state;
                var Selected_Members_Data = this.state.selected_members_in_state;
                var AM = Available_members_Data.filter(this.comparer(Selected_Members_Data));

                FilteredData = AM.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                if (FilteredData.length != 0) {
                    Available_members = FilteredData.map(el => (
                        <tr id={el.objectId} className="RightTablerecords" key={el.objectId}>
                            <td><input type="checkbox" id={el.objectId} className="Available_members_left" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Available_members_left", "available_members_header_Check_box"); }} /></td>
                            <td id={el.objectId}>{el.objectName}</td>
                        </tr>
                    ));
                } else {
                    Available_members = <tr><td>{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
                }

                Selected_Members = Selected_Members_Data.map(el => (
                    <tr id={el.objectId} className="RightTablerecords" key={el.objectId}>
                        <td><input type="checkbox" id={el.objectId} className="Available_members_right" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("Available_members_right", "selected_members_header_Check_box"); }} /></td>
                        <td id={el.objectId}>{el.objectName}</td>
                    </tr>
                ));
            }
        }
        else {
            Available_members = <tr><td>{label['NoRecords.Text'] !== undefined ? label['NoRecords.Text'] : "No Records Found"}</td></tr>
        }

        
        // Error Msg
        if(this.state.error){
            var errormsg =   <p  className="error_msg">
            <img src={ErrorGif} alt="Trane Logo" /> 
            {Error_Msg}
            </p> 
        }
        modal_form_1 = <div className="">
                        {errormsg}
                        <h4 className="Modal_form_title">{label['TenantZones.EditHeaderText.Text'] !== undefined ? label['TenantZones.EditHeaderText.Text'] : "Edit Zone"}</h4>
                        <div className="Modal_form_group ">
                            <label className="Modal_label"><b>{label['TenantZones.Name.Text'] !== undefined ? label['TenantZones.Name.Text'] : "Name"}</b></label>
                            <input ref='New_Zone_Name' defaultValue={ZoneName} className="Modal_input_regular default-input" maxLength="200"/>
                        </div>

                        <div className="Modal_form_group ">
                            <label className="Modal_label"><b>{label['TenantZones.Building.Text'] !== undefined ? label['TenantZones.Building.Text'] : "Building"}</b></label>
                            <label className="Modal_label">{BuildingName}</label>
                        </div>

                        <div className="Modal_sublabel_group">
                            <label className="Modal_label"><b>{label['TenantZones.FilterBy.Text'] !== undefined ? label['TenantZones.FilterBy.Text'] : "Filter by"}</b></label>
                        </div>
                        <div></div>
                        <div className="Modal_form_group ">
                            <label className="Modal_label">{label['TenantZones.ShowOnly.Text'] !== undefined ? label['TenantZones.ShowOnly.Text'] : "Member Type"}</label>
                            <select ref='Building_in_Select_input' className="Modal_input_regular " id="MemberSelectoption" onChange={() => { this.changeMemberType(); }} style={{"width":"150px","marginRight":"50px"}}>
                                <option value="ShowAll" >{label['TenantZones.ShowAll.Text'] !== undefined ? label['TenantZones.ShowAll.Text'] : "Show All"}</option>
                                <option id="1" value="1">{label['TenantZones.Spaces.Text'] !== undefined ? label['TenantZones.Spaces.Text'] : "Spaces"}</option>
                                <option id="11" value="11">{label['TenantZones.Areas.Text'] !== undefined ? label['TenantZones.Areas.Text'] : "Areas"}</option>
                                <option id="7" value="7">{label['TenantZones.Binary.Text'] !== undefined ? label['TenantZones.Binary.Text'] : "Binary Points"}</option>
                            </select>
                            <SearchInput  onChange={this.searchUpdated}  />
                        </div>
                        
                        <div class="Modal_form_group"></div>
                        <Row >
                            <Col sm={{ size: 4 }}>
                                <div className="members_left_table" style={{overflowX:"auto",maxHeight:"300px"}}>
                                    <Table striped responsive className="Custom_table right_table">
                                        <thead>
                                            <tr>
                                                <th><input type="checkbox" className="available_members_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Available_members_left","available_members_header_Check_box"); }} /></th>
                                                <th>{label['TenantZones.Columns.AvailableMembers.Text'] !== undefined ? label['TenantZones.Columns.AvailableMembers.Text'] : "Available Members"} </th>
                                            </tr>
                                            {Available_members}
                                        </thead>
                                    </Table>
                                </div>
                            </Col>
                            <Col sm={{ size: 2,offset: 1 }}>
                                <Button className="btn-black btn-md AddZone_Addbtn" onClick={() => { this.moveRowsToRight(); }} >{label['TenantZones.btnMembersAdd.Text'] !== undefined ? label['TenantZones.btnMembersAdd.Text'] : "Add >"} </Button>
                                
                                <Button className="btn-black btn-md AddZone_Removebtn" style={{"margin-top": "5%"}}  onClick={() => { this.moveRowsToLeft(); }}  >{label['TenantZones.btnMembersRemove.Text'] !== undefined ? label['TenantZones.btnMembersRemove.Text'] : "< Remove"} </Button>
                            </Col>
                            <Col sm={{ size: 4,offset: 1 }}>
                                <div className="members_right_table" style={{overflowX:"auto",maxHeight:"300px"}}>
                                    <Table striped responsive className="Custom_table left_table">
                                        <thead>
                                            <tr>
                                                <th><input type="checkbox"className="selected_members_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("Available_members_right","selected_members_header_Check_box"); }} /></th>
                                                <th>{label['TenantZones.Columns.SelectedMembers.Text'] !== undefined ? label['TenantZones.Columns.SelectedMembers.Text'] : "Selected Members"} </th>
                                            </tr>
                                            {Selected_Members}
                                        </thead>
                                    </Table>
                                </div>
                            </Col>
                        </Row>

                        <FormGroup row className="btns_group">
                            <Col sm={{ size: 12 }}>
                                <Button className="btn-gray btn-md"  onClick={this.CloseModal} > {label['TenantZones.Cancel.Text'] !== undefined ? label['TenantZones.Cancel.Text'] : "Cancel"}</Button>
                                <Button className="btn-success btn-md"  onClick={this.UpdateZone} > {label['TenantZones.btnFinish.Text'] !== undefined ? label['TenantZones.btnFinish.Text'] : "Finish"} </Button>
                            </Col>
                        </FormGroup>
                        </div>
        return (
            <div>
                {modal_form_1}
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        getResponse: state.zonesRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        Response_of_MembersCall: state.MembersRootReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetZonesList: () => dispatch(GetZonesList()),
        GetBuildingMembersList: (buildingid) => dispatch(GetBuildingMembersList(buildingid)),
        GetMembersFromFamily: (buildingid,familyId) => dispatch(GetMembersFromFamily(buildingid,familyId)),
        closeModalPopUp: (data) => dispatch(closeModalPopUp(data)),
        UpdateZone: (data) => dispatch(UpdateZone(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditZoneForm);